import { config } from '../../config/config';
import { getVariables } from '../shared/helpers/get-functions';
import { getCookie } from '../shared/hooks/use-cookie';

const GATEWAY_TOKEN = 'gateway_token';

export async function gateway(): Promise<void> {
  const url = new URL(window.location.href);
  const token = url.searchParams.get(GATEWAY_TOKEN);

  if (!token) return;

  const requestData = {
    id: 1,
    jsonrpc: '2.0',
    method: 'get',
    params: { key: token },
  };

  try {
    const res = await fetch(config.REQUESTS.OPTIONS, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': config.HEADERS.AUTHORIZATION,
      },
      body: JSON.stringify(requestData),
    });

    if (!res.ok) {
      throw new Error('Token verification failed');
    }

    const data = await res.json();

    if (
      data?.result?.options?.user_data &&
      data.result.options.user_data.id_token &&
      data.result.options.user_data.access_token
    ) {
      const { id_token, access_token, refresh_token } = data.result.options.user_data;
      const profile = JSON.parse(atob(id_token.split('.')[1]));
      const accessToken = JSON.parse(atob(access_token.split('.')[1]));
      const state = accessToken.sid;
      const ga = getCookie('_ga');
      const { storageKey, customerUserIdKey } = getVariables();

      const storedAuthenticationState = {
        access_token,
        refresh_token,
        id_token,
        profile,
        state,
        expires_at: accessToken.exp,
        token_type: accessToken.typ,
        scope: accessToken.scope,
      };

      localStorage.setItem(storageKey, JSON.stringify(storedAuthenticationState));

      if (data.result.options.user_data.custom_user_id) {
        localStorage.setItem(customerUserIdKey, data.result.options.user_data.custom_user_id);
      }

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'login',
          method: 'Root landing login',
          user_id: profile.user_profile_id,
          ga4_id: ga ?? '',
        });
      }
    }
  } catch (err) {
    console.error('Error verifying gateway token:', err);
  }

  url.searchParams.delete(GATEWAY_TOKEN);
  window.history.replaceState({}, '', url.toString());
}
